import styled from "styled-components";
import Container from "components/core/container";
import Spinner from "components/spinner";

const PageLoader = ({ label = "" }) => {
  return (
    <PageLoaderWrapper>
      <Container padding={[0, 0, 0, 0]}>
        <Spinner label={label} />
      </Container>
    </PageLoaderWrapper>
  );
};

const PageLoaderWrapper = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    min-height: calc(100vh - 146px);
  }
`;

export default PageLoader;
